import { AppDispatch, getPageStateSafe, globalStore } from '@app/model/store/client'

import SelectionItemReducer, {
  setAfishaSelectedList,
  setLoading,
  setPagination,
  setParamsRequest,
  setRecommendationList,
  setSelection,
  setSelectionList,
} from '@pages/SelectionItem/model/slice'

import type { SelectionItemServerData } from '@pages/SelectionItem/model/types'

const fallbackSelectionItemState = SelectionItemReducer(undefined, { type: 'init' })

export const initSelectionItem = (data: SelectionItemServerData) => async (dispatch: AppDispatch) => {
  const stateSelection = getPageStateSafe(globalStore.getState(), 'selection_item', fallbackSelectionItemState)

  dispatch(setSelection(data.selection.description))
  dispatch(setAfishaSelectedList(data.afishaSelected ?? null))
  dispatch(setRecommendationList(data.recommendation ?? null))
  dispatch(setSelectionList(data.selection.restaurants ?? null))

  let paramsRequest = data.selection.requestParams
  if (paramsRequest) {
    if (typeof paramsRequest.path === 'number') {
      // ищем slug по id в data.selection.description
      const selection = data.selection.description
      if (selection && selection.id === paramsRequest.path && selection.url.slug) {
        paramsRequest = { ...paramsRequest, path: selection.url.slug }
      }
    } else if (typeof paramsRequest.path === 'object') {
      const selection = data.selection.description
      if (selection?.url.slug) {
        paramsRequest = { ...paramsRequest, path: selection.url.slug }
      }
    }
  }

  dispatch(setParamsRequest(paramsRequest))
  dispatch(setPagination(data.selection.pagination ?? null))

  dispatch(setLoading({ ...stateSelection.selection.loading, page: false }))
}
